import { render } from "./PressFilters.vue?vue&type=template&id=278d74a7"
import script from "./PressFilters.vue?vue&type=script&lang=js"
export * from "./PressFilters.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Tiresias\\Tiresias Project\\UI.Tiresias\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/Press/PressFilters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "278d74a7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('278d74a7', __exports__)) {
    api.reload('278d74a7', __exports__)
  }
  
  module.hot.accept("./PressFilters.vue?vue&type=template&id=278d74a7", () => {
    api.rerender('278d74a7', render)
  })

}


export default __exports__